<template>
  <div class="min-h-screen grid place-items-center px-6">
    <article
      class="max-w-md w-full rounded-2xl p-8 shadow-xl text-center"
      style="background: var(--bg-elev); color: var(--fg)"
    >
      <h1 class="text-xl font-semibold mb-2">{{ heading }}</h1>
      <p class="mb-6" style="color: var(--fg-muted)">{{ body }}</p>
      <button
        type="button"
        class="px-4 py-2 rounded-lg font-medium"
        style="background: var(--accent); color: var(--accent-fg)"
        @click="auth.signOut"
      >
        Sign out
      </button>
    </article>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const auth = useAuthStore();
const route = useRoute();
const isForbidden = computed(() => route.meta.forbidden === true);
const heading = computed(() => (isForbidden.value ? "Not allowed" : "Wrong account"));
const body = computed(() =>
  isForbidden.value
    ? "Your account doesn't have access to this page. Ask an admin to update your role."
    : "Sign in with your @foodics.com Google account to continue.",
);
</script>
